// A compact set of common cities for the Panchangam location picker.
// tz is the offset from UTC in minutes.
export const CITIES = [
  { name: "New Delhi", lat: 28.6139, lon: 77.209, tz: 330 },
  { name: "Mumbai", lat: 19.076, lon: 72.8777, tz: 330 },
  { name: "Kolkata", lat: 22.5726, lon: 88.3639, tz: 330 },
  { name: "Chennai", lat: 13.0827, lon: 80.2707, tz: 330 },
  { name: "Bengaluru", lat: 12.9716, lon: 77.5946, tz: 330 },
  { name: "Hyderabad", lat: 17.385, lon: 78.4867, tz: 330 },
  { name: "Pune", lat: 18.5204, lon: 73.8567, tz: 330 },
  { name: "Ahmedabad", lat: 23.0225, lon: 72.5714, tz: 330 },
  { name: "Jaipur", lat: 26.9124, lon: 75.7873, tz: 330 },
  { name: "Lucknow", lat: 26.8467, lon: 80.9462, tz: 330 },
  { name: "Varanasi", lat: 25.3176, lon: 82.9739, tz: 330 },
  { name: "Patna", lat: 25.5941, lon: 85.1376, tz: 330 },
  { name: "Bhubaneswar", lat: 20.2961, lon: 85.8245, tz: 330 },
  { name: "Guwahati", lat: 26.1445, lon: 91.7362, tz: 330 },
  { name: "Tirupati", lat: 13.6288, lon: 79.4192, tz: 330 },
  { name: "Ujjain", lat: 23.1765, lon: 75.7885, tz: 330 },
  { name: "Haridwar", lat: 29.9457, lon: 78.1642, tz: 330 },
  { name: "London", lat: 51.5074, lon: -0.1278, tz: 0 },
  { name: "New York", lat: 40.7128, lon: -74.006, tz: -300 },
  { name: "Dubai", lat: 25.2048, lon: 55.2708, tz: 240 },
  { name: "Singapore", lat: 1.3521, lon: 103.8198, tz: 480 },
  { name: "Sydney", lat: -33.8688, lon: 151.2093, tz: 660 },
];

const KEY = "dharmartha_loc";

export function getSavedLocation() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setSavedLocation(city) {
  localStorage.setItem(KEY, JSON.stringify(city));
}

// Current wall-clock time AT the saved location — never the browser's.
// Prefers the IANA tz_id (DST-accurate via Intl); falls back to the stored
// UTC offset (minutes), then to the browser. Returns {year,month,day,hour,min}.
export function nowInLocation(loc) {
  const d = new Date();
  const tzId = loc && loc.tz_id;
  if (tzId) {
    try {
      const parts = new Intl.DateTimeFormat("en-CA", {
        timeZone: tzId, year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", hour12: false,
      }).formatToParts(d).reduce((a, p) => { a[p.type] = p.value; return a; }, {});
      const hour = parts.hour === "24" ? 0 : parseInt(parts.hour, 10);
      return { year: +parts.year, month: +parts.month, day: +parts.day, hour, min: +parts.minute };
    } catch { /* fall through to offset */ }
  }
  const off = typeof (loc && loc.tz) === "number" ? loc.tz : -d.getTimezoneOffset();
  const c = new Date(d.getTime() + off * 60000);
  return { year: c.getUTCFullYear(), month: c.getUTCMonth() + 1, day: c.getUTCDate(), hour: c.getUTCHours(), min: c.getUTCMinutes() };
}

// "HH:MM" of a {hour,min} parts object.
export const hmOf = (p) => `${String(p.hour).padStart(2, "0")}:${String(p.min).padStart(2, "0")}`;
